import React, { Component, Fragment } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import {
  DatePickerField,
  CheckboxField,
  InputField,
} from 'Common/SemanticWrapper';
import { CEP_FUNDS_DUE_REPORT_FORM_NAME, InputMode } from 'Common/FormEnum';
import { CEPFundsDueReportFieldEnum as Fields } from 'Common/FieldEnum';
import { TitledCard } from 'Components/';
import SelectSitesTable from 'Common/SelectSitesTable';
import { setSelectedSites } from '../state/report/actions';
import { formatDecimal } from 'Common/FormHelper';

class CEPFundsDueReportFormContainer extends Component {
  onSiteChange = sites => {
    this.props.setSelectedSites(sites);
  };

  render() {
    return (
      <Fragment>
        <TitledCard title={'Amount Due Per Meal'}>
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  label={'Breakfast'}
                  component={InputField}
                  mode={InputMode.Decimal}
                  name={Fields.AmtDueBfst}
                  formatOnBlur={formatDecimal(2)}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'Lunch'}
                  component={InputField}
                  mode={InputMode.Decimal}
                  name={Fields.AmtDueLunch}
                  formatOnBlur={formatDecimal(2)}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard>
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  label={'From Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  label={'To Date'}
                  name={Fields.ToDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                />
              </Grid.Column>
              <Grid.Column>
                <div style={{ marginTop: 50 }}>
                  <Field
                    label={'Summary Only'}
                    name={Fields.SummaryOnly}
                    component={CheckboxField}
                  />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard>
          <SelectSitesTable
            onChange={this.onSiteChange}
            sites={this.props.sites}
            fetchSites={false}
          />
        </TitledCard>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  //===================
  //Validate Amount Due
  //===================

  let bfstAmt = parseFloat(
    values[Fields.AmtDueBfst] ? values[Fields.AmtDueBfst] : 0
  );
  let lunchAmt = parseFloat(
    values[Fields.AmtDueLunch] ? values[Fields.AmtDueLunch] : 0
  );

  if (bfstAmt + lunchAmt <= 0) {
    errors[Fields.AmtDueBfst] = 'Breakfast or Lunch must be greater than zero.';
  }

  //=================
  // Validate Dates
  //=================

  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }

  if (
    !moment(values[Fields.ToDate]).isSame(values[Fields.FromDate]) &&
    values[Fields.FromDate]
  ) {
    if (!moment(values[Fields.ToDate]).isAfter(values[Fields.FromDate])) {
      errors[Fields.ToDate] = 'To Date must be equal or after From Date.';
    }
  }

  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }

  return errors;
};

const mapStateToProps = state => {
  const { sites } = state.CEPFundsDueReportState.report;

  return {
    sites: sites,
  };
};

const CEPFundsDueReportForm = reduxForm({
  form: CEP_FUNDS_DUE_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(
      mapStateToProps,
      { setSelectedSites }
    )(CEPFundsDueReportFormContainer)
  )
);

export { CEPFundsDueReportForm };



// WEBPACK FOOTER //
// ./src/pages/cepfundsdue/components/CEPFundsDueReportForm.js